import { ErrorBoundary } from '@tecton/ComponentRedesign';
import { FC, useState } from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router';
import { FlexGroup, FlexItem, ViewLayout } from '@lithos';

import JobDetailMetadata from './JobDetailMetadata';
// types
import JobDetailStages from './JobDetailStages';
import JobLogs from './JobLogs';
import { getJobDetailRouteName, getJobDetailRoutes, JobDetailRoutes } from './jobUtils';
import JobMetrics from './JobMetrics';

const JobDetails: FC = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<Navigate to={'stages'} replace />} />
        <Route path={`stages`} element={<JobDetailStages />} />
        <Route
          path={`metadata`}
          element={
            <>
              <JobDetailMetadata />
            </>
          }
        />
        <Route
          path={`metrics`}
          element={
            <>
              <JobMetrics />
            </>
          }
        />
        <Route
          path={`logs`}
          element={
            <>
              <JobLogs />
            </>
          }
        />
      </Route>
    </Routes>
  );
};

const JobDetailsContainer = () => {
  const { jobId } = useParams();
  const navigation = useNavigate();
  const jobRoutes = getJobDetailRouteName(location.pathname);
  const [selectedTab, setSelectedTab] = useState<JobDetailRoutes>(jobRoutes);

  const jobDetailRoutes = getJobDetailRoutes();
  const routeNames = Object.keys(jobDetailRoutes);

  return (
    <ErrorBoundary>
      <ViewLayout
        header={{
          title: jobId,
          breadcrumbs: {
            root: { label: 'Jobs', url: '/jobs' },
            items: [{ label: jobId }],
          },
          tabs: {
            items: routeNames.map((routeName) => ({ label: routeName, value: routeName })),
            selectedTab: selectedTab,
            setSelectedTab: (tab: JobDetailRoutes) => {
              navigation(jobDetailRoutes[tab]);
              setSelectedTab(tab);
            },
          },
        }}
        content={
          <FlexGroup padding="0">
            <FlexItem>
              <JobDetails />
            </FlexItem>
          </FlexGroup>
        }
      />
    </ErrorBoundary>
  );
};

export default JobDetailsContainer;
